"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHourglassFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M19.28 14.59a11.66 11.66 0 002.41-1.78C24 10.52 24 6.53 24 4.39V4h2V2H6v2h2v.39c0 2 0 6.1 2.3 8.42a11 11 0 002.42 1.78c1.07.64 1.28.81 1.28 1.41s-.21.78-1.28 1.41a11.66 11.66 0 00-2.41 1.78C8.07 21.41 8 25 8 28H6v2h20v-2h-2c0-2.84-.08-6.57-2.3-8.81a11 11 0 00-2.42-1.78C18.21 16.77 18 16.6 18 16s.21-.78 1.28-1.41z" })));
}
exports.default = SvgHourglassFilled;
//# sourceMappingURL=HourglassFilled.js.map